(() => {
  'use strict';
  if (window.__MM_CLUB_PRODUCT_LOCALE_V3__) {
    window.__MM_CLUB_PRODUCT_LOCALE_V3__.initialize(document);
    return;
  }

  const initialized = new WeakSet();
  const isSpanish = () => (document.documentElement.lang || '').toLowerCase().startsWith('es');

  const cadenceFromRoot = (root) => {
    const picker = root.querySelector('[data-mm-plan-picker]');
    const select = picker?.querySelector('select[name="selling_plan"]:not(:disabled)');
    const option = select?.selectedOptions?.[0];
    const radio = picker?.querySelector('input[name="selling_plan"]:checked:not(:disabled)');
    const radioLabel = radio?.closest('label')?.textContent || '';
    const interval = (option?.dataset.planInterval || radio?.dataset.planInterval || '').toLowerCase();
    const count = Number.parseInt(option?.dataset.planIntervalCount || radio?.dataset.planIntervalCount || '1', 10);

    if (interval === 'month' && count > 1) return `Cada ${count} meses`;
    if (interval === 'month') return 'Mensual';
    if (interval === 'week' && count > 1) return `Cada ${count} semanas`;
    if (interval === 'week') return 'Semanal';
    if (interval === 'year' && count > 1) return `Cada ${count} años`;
    if (interval === 'year') return 'Anual';
    if (interval === 'day' && count > 1) return `Cada ${count} días`;
    if (interval === 'day') return 'Diaria';

    const source = [
      option?.textContent || '',
      radioLabel,
      root.querySelector('.r32-club-offer strong')?.textContent || ''
    ].join(' ').toLowerCase();

    const numericMonths = source.match(/(?:every|cada)\s+(\d+)\s+(?:months?|meses?)/);
    if (numericMonths) {
      const months = Number.parseInt(numericMonths[1], 10);
      if (months > 1) return `Cada ${months} meses`;
    }
    if (/bimonthly|bi-monthly|every other month|cada dos meses/.test(source)) return 'Cada 2 meses';

    const numericWeeks = source.match(/(?:every|cada)\s+(\d+)\s+(?:weeks?|semanas?)/);
    if (numericWeeks) {
      const weeks = Number.parseInt(numericWeeks[1], 10);
      if (weeks > 1) return `Cada ${weeks} semanas`;
    }
    if (/weekly|semanal/.test(source)) return 'Semanal';

    const numericYears = source.match(/(?:every|cada)\s+(\d+)\s+(?:years?|años?)/);
    if (numericYears) {
      const years = Number.parseInt(numericYears[1], 10);
      if (years > 1) return `Cada ${years} años`;
    }
    if (/annual|annually|yearly|anual/.test(source)) return 'Anual';

    const numericDays = source.match(/(?:every|cada)\s+(\d+)\s+(?:days?|días?)/);
    if (numericDays) {
      const days = Number.parseInt(numericDays[1], 10);
      if (days > 1) return `Cada ${days} días`;
    }
    if (/daily|diaria/.test(source)) return 'Diaria';

    return 'Mensual';
  };

  const setButtonText = (button, text) => {
    if (!button || button.querySelector('[data-mm-purchase-label]')) return;
    [...button.childNodes]
      .filter(node => node.nodeType === Node.TEXT_NODE)
      .forEach(node => node.remove());
    button.append(document.createTextNode(` ${text}`));
  };

  const renderProduct = (root) => {
    if (!isSpanish()) return;
    const cadence = cadenceFromRoot(root);
    const offer = root.querySelector('.r32-club-offer');
    const offerTitle = offer?.querySelector('strong');
    const offerNote = offer?.querySelector('small');
    if (offerTitle) offerTitle.textContent = cadence === 'Mensual' ? 'Suscripción mensual' : `Suscripción ${cadence.toLowerCase()}`;
    if (offerNote) {
      offerNote.textContent = 'La selección varía dentro de la marca, escala o tipo de club descrito abajo. Las fotos de ejemplo no garantizan un artículo concreto.';
    }

    const quantity = root.querySelector('.r32-quantity');
    const quantityLabel = quantity?.previousElementSibling;
    if (quantityLabel?.tagName === 'LABEL') quantityLabel.textContent = 'Número de suscripciones';

    setButtonText(root.querySelector('.mm-product-form > .r32-button[type="submit"]'), 'Iniciar club');

    const specRows = [...root.querySelectorAll('.r32-club-specs:not([data-mm-club-specs-localized]) > div')];
    const labels = ['Frecuencia', 'Precio', 'Renovación', 'Selección'];
    specRows.forEach((row, index) => {
      const term = row.querySelector('dt');
      if (term && labels[index]) term.textContent = labels[index];
    });
    const schedule = specRows[0]?.querySelector('dd');
    const renewal = specRows[2]?.querySelector('dd');
    const selection = specRows[3]?.querySelector('dd');
    if (schedule) schedule.textContent = cadence;
    if (renewal) renewal.textContent = 'Automática hasta que canceles antes de la próxima renovación.';
    if (selection) selection.textContent = 'Muncle Mikes elige entre la línea elegible del club; los artículos fotografiados no están garantizados.';
  };

  const renderRelated = (scope = document) => {
    if (!isSpanish()) return;
    scope.querySelectorAll?.('.mm-reco[data-product-id]').forEach(section => {
      const eyebrow = section.querySelector('.mm-reco-heading .mm-reco-eyebrow');
      const heading = section.querySelector('.mm-reco-heading h2');
      const intro = section.querySelector('.mm-reco-heading .mm-reco-intro');
      const browse = section.querySelector('.mm-reco-heading .mm-reco-browse');
      const alternatives = section.querySelector('[data-reco-group="related"] .mm-reco-group-heading h3');
      if (eyebrow?.textContent.trim() === 'COMPARE CLUBS') eyebrow.textContent = 'COMPARAR CLUBES';
      if (heading?.textContent.trim() === 'Other Clubs You May Like') heading.textContent = 'Otros clubes que te pueden gustar';
      if (intro?.textContent.trim() === 'Compare other clubs in the same hobby lane and scale when available.') {
        intro.textContent = 'Compara otros clubes de la misma afición y escala cuando estén disponibles.';
      }
      if (browse?.textContent.includes('View all clubs')) browse.innerHTML = 'Ver todos los clubes <span aria-hidden="true">→</span>';
      if (alternatives?.textContent.trim() === 'Clubs to compare') alternatives.textContent = 'Clubes para comparar';
    });
  };

  const renderRevenueGuidance = (scope = document) => {
    scope.querySelectorAll?.('[data-mm-revenue-build="subscription-v6"]').forEach(section => {
      const eyebrow = section.querySelector('.mm-revenue__eyebrow');
      const heading = section.querySelector('.mm-revenue__section-head h2');
      const intro = section.querySelector('.mm-revenue__section-head p:last-child');
      if (isSpanish()) {
        if (eyebrow) eyebrow.textContent = 'TU SUSCRIPCIÓN';
        if (heading) heading.textContent = 'Gestiona tu suscripción';
        if (intro) intro.textContent = 'Revisa tu plan, sigue tus entregas y consulta tus beneficios de suscriptor.';
      } else {
        if (eyebrow) eyebrow.textContent = 'YOUR SUBSCRIPTION';
        if (heading) heading.textContent = 'Manage your subscription';
        if (intro) intro.textContent = 'Review your plan, track deliveries and see your subscriber benefits.';
      }
    });
  };

  const initializeRoot = (root) => {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    renderProduct(root);
    root.addEventListener('change', event => {
      if (event.target.matches('[name="id"], [name="selling_plan"]')) queueMicrotask(() => renderProduct(root));
    });
  };

  const initialize = (scope = document) => {
    if (scope.matches?.('.r32-product--club[data-mm-product-root]')) initializeRoot(scope);
    scope.querySelectorAll?.('.r32-product--club[data-mm-product-root]').forEach(initializeRoot);
    renderRelated(scope);
    renderRevenueGuidance(scope);
  };

  window.__MM_CLUB_PRODUCT_LOCALE_V3__ = { initialize };
  window.__MM_CLUB_PRODUCT_LOCALE_V2__ = window.__MM_CLUB_PRODUCT_LOCALE_V3__;
  window.__MM_CLUB_PRODUCT_LOCALE_V1__ = window.__MM_CLUB_PRODUCT_LOCALE_V3__;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
